// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"fd5aec52","459":"7a96d9c8","595":"da0ee5e1","957":"9bae2c80"}[chunkId] + ".chunk.js";
};